import NTabItem from './NTabItem';

export default NTabItem